export const blockIconsHomeArrowsMoreUpNew = (
	<span className='material-symbols-outlined'>arrows_more_up</span>
);
